// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    'backbone'
], (Globals, $, _, Backbone) => {
    const ReportPropertyModel = Backbone.Model.extend({
        urlRoot: Globals.baseUrl + 'reports/report',
        urlPropertyValues: Globals.baseUrl + 'reportProperties/getReportPropertyValues',
        defaults: {
        },
        initialize() {
        },
        fetchPropertyValues(options) {
            const model = this;
            const data = model.getSqlData();
            // if data
            data.report_id = model.get('report_id');
            data.property_name = model.id;
            $.ajax({
                url: _.isUndefined(options.url) ? model.urlPropertyValues : options.url,
                data,
                dataType: 'JSON',
                success(data2) {
                    model.set('propertyValues', data2);
                    if (_.isFunction(options.success)) {
                        options.success(model, data2);
                    }
                }
            });
        },
        getSqlData() {
            let data = {};
            if (!_.isUndefined(this.get('formValues')) && !_.isUndefined(this.get('dialog_sql_param_0'))) {
                let i = 0;
                do {
                    const parameter = this.get('dialog_sql_param_' + i);
                    const formValues = this.get('formValues');
                    if (!_.isUndefined(formValues[parameter])) {
                        data[parameter] = formValues[parameter];
                    }
                    i += 1;
                } while (!_.isUndefined(this.get('dialog_sql_param_' + i)));
            } else if (!_.isUndefined(this.get('formValues'))) {
                data = this.get('formValues');
            }
            return data;
        }
    });
    return ReportPropertyModel;
});



// WEBPACK FOOTER //
// ./src/components/report/models/ReportPropertyModel.js